import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "../../../components/svgs";

const steps = [
  {
    number: "01",
    tag: "TRAIN",
    title: "Train your talent",
    desc:
      "Build AI, technology, business and leadership capabilities through practical programmes shaped around your organisation.",
    points: [
      "Capability assessment",
      "Custom learning pathways",
      "Projects tied to business goals",
    ],
    cta: "Train my talent",
    to: "/enterprise",
  },
  {
    number: "02",
    tag: "HIRE",
    title: "Hire Talents",
    desc:
      "Access focused, job-ready professionals and make confident hiring decisions using skills evidence and human context.",
    points: [
      "Role-focused talent matching",
      "Verified skills evidence",
      "Focused candidate shortlists",
    ],
    cta: "Hire talent",
    to: "/hire",
  },
  {
    number: "03",
    tag: "PAY",
    title: "Pay Globally",
    desc:
      "Onboard, manage and pay employees or contractors across borders through coordinated global workforce support.",
    points: [
      "Compliant onboarding support",
      "Multi-currency payments",
      "Ongoing workforce operations",
    ],
    cta: "Pay globally",
    to: "/pay",
  },
];

const HomeBusinessSection = () => {
  return (
    <section className="hire-grid-bg text-white py-16 md:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-secondary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
            <span className="w-8 h-[3px] bg-secondary inline-block"></span>
            For business
          </p>
          <h2 className="text-white font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-6xl mb-6 max-w-3xl">
            Train your talent. Hire Talents. Pay Globally.
          </h2>
          <p className="text-[#d7dfff] font-poppins text-lg leading-[1.8] mb-10 md:mb-12 max-w-3xl">
            One connected partnership for building the people you have, finding
            the people you need and supporting teams wherever they work.
          </p>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="relative grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-5">
            {steps.map((step) => (
              <article
                key={step.number}
                className="bg-lightBlue border border-[#fff3] rounded-2xl p-6 md:p-7 flex flex-col"
              >
                <div className="flex items-center justify-between mb-14">
                  <span className="w-10 h-10 font-poppins border border-secondary text-secondary rounded-full grid place-items-center text-sm font-bold">
                    {step.number}
                  </span>
                  <span className="text-secondary font-poppins tracking-[0.09em] text-sm font-extrabold">
                    {step.tag}
                  </span>
                </div>

                <h3 className="text-white font-poppins font-bold text-3xl mb-3">
                  {step.title}
                </h3>
                <p className="text-[#d7dfff] font-poppins text-base leading-[1.7] mb-6">
                  {step.desc}
                </p>

                <ul className="grid gap-2.5 mb-6">
                  {step.points.map((point) => (
                    <li
                      key={point}
                      className="flex items-center gap-2.5 text-white font-poppins text-base"
                    >
                      <span className="text-secondary" aria-hidden="true">
                        ✓
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>

                <Link
                  to={step.to}
                  className="mt-auto pt-5 border-t border-white/[0.22] text-secondary font-poppins font-bold text-base flex items-center justify-between hover:opacity-80 transition-all"
                >
                  {step.cta}
                  <span aria-hidden="true">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </span>
                </Link>
              </article>
            ))}

            {[1, 2].map((position) => (
              <span
                key={position}
                className="hidden md:grid absolute z-10 top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-secondary text-primary place-items-center"
                style={{ left: `${position * (100 / 3)}%` }}
                aria-hidden="true"
              >
                <ArrowRight fill="currentColor" />
              </span>
            ))}
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="bg-primary2 rounded-2xl mt-8 px-6 py-7 sm:px-8 md:px-10 md:py-8 flex flex-wrap items-center gap-6 md:gap-10">
            <p
              className="text-secondary font-poppins tracking-[0.09em] text-xs font-extrabold uppercase shrink-0 m-0"
              style={{ maxWidth: "10rem" }}
            >
              One Utiva Business Relationship
            </p>
            <p className="text-white font-poppins font-bold text-lg md:text-xl leading-snug flex-1 min-w-[240px] m-0">
              Develop stronger people. Build better teams. Operate without
              borders.
            </p>
            <a
              href="#request"
              className="bg-secondary text-primary font-poppins rounded-xl min-h-[50px] px-6 inline-flex items-center gap-3 text-sm font-bold hover:-translate-y-0.5 transition-all shrink-0"
            >
              Talk to Utiva for Business{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </a>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HomeBusinessSection;
